import React, { FC } from "react";
import Logo from "shared/Logo/Logo";
import { NavigationNew } from "shared/Navigation/Navigation";
import SearchDropdown from "./SearchDropdown";
import MenuBar from "shared/MenuBar/MenuBar";
import SwitchDarkMode from "shared/SwitchDarkMode/SwitchDarkMode";
import { Link } from "react-router-dom";

export interface MainNav1Props {
  className?: string;
  isDark?: boolean;
}

const MainNav1: FC<MainNav1Props> = ({ className = "", isDark = false }) => {
  return (
    <div className={`nc-MainNav1 relative z-10 ${className}`}>
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-[4.5rem] gap-3">
          <div className="flex-shrink-0">
            <Logo className="w-14 sm:w-16 md:w-20" isDark={isDark} />
          </div>

          <nav className="hidden lg:flex flex-1 justify-center mx-4">
            <NavigationNew isDark={isDark} />
          </nav>

          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
            <SwitchDarkMode
              className={`hidden sm:flex ${isDark ? "!text-white/80" : ""}`}
            />
            <SearchDropdown isDark={isDark} />
            <Link
              to="/contact"
              className={`hidden md:inline-flex text-xs sm:text-sm font-semibold whitespace-nowrap rounded-full px-5 py-2.5 transition-all ${
                isDark
                  ? "bg-white text-[#0f1b3d] hover:bg-white/90"
                  : "bcr-btn-primary !px-5 !py-2.5"
              }`}
            >
              Contact Us
            </Link>
            <div className="lg:hidden">
              <MenuBar isDark={isDark} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav1;
